import { useConfigurator } from '@nespresso/vue-configurator';
import config from './config';

const className = 'NaBlocks';

export default useConfigurator(config, className, { disablePropsBinding: true });
